import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  theme: {
    primary: "#F03C0C",
    secondary: "#FAFAFA",
    accent: "#14B9D6",
    error: "#D0021B",
    warning: "#FFC200",
    info: "#666666",
    success: "#5CB85C"
  },
  options: {
    customProperties: true
  },
  iconfont: "mdi"
});
